import { useState, type FormEvent } from "react";
import { useLocation } from "react-router-dom";
import { changePassword, getStoredAdmin } from "@/lib/auth";
import { ApiError } from "@/lib/api";
import { Field } from "@/components/funnel/Field";

export default function AdminSettings() {
  const admin = getStoredAdmin();
  const location = useLocation();
  const mustChange = !!(location.state as { mustChange?: boolean } | null)?.mustChange;

  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [msg, setMsg] = useState<{ kind: "ok" | "err"; text: string } | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e: FormEvent) => {
    e.preventDefault();
    setMsg(null);

    if (next.length < 8) {
      setMsg({ kind: "err", text: "Nova senha precisa ter pelo menos 8 caracteres." });
      return;
    }
    if (next !== confirm) {
      setMsg({ kind: "err", text: "Confirmacao de senha nao confere." });
      return;
    }

    setSubmitting(true);
    try {
      await changePassword(current, next);
      setMsg({ kind: "ok", text: "Senha alterada com sucesso." });
      setCurrent("");
      setNext("");
      setConfirm("");
    } catch (err) {
      if (err instanceof ApiError && err.payload && typeof err.payload === "object") {
        const reason = (err.payload as { error?: string }).error;
        if (reason === "wrong_password") setMsg({ kind: "err", text: "Senha atual incorreta." });
        else setMsg({ kind: "err", text: "Erro ao trocar senha." });
      } else {
        setMsg({ kind: "err", text: "Erro ao trocar senha." });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="adm-topbar">
        <div>
          <h1 className="adm-title">Configuracoes</h1>
          <p className="adm-sub">Gerencie sua conta de acesso.</p>
        </div>
      </div>

      {mustChange && (
        <div
          className="adm-login-error"
          style={{
            background: "oklch(0.76 0.105 78 / .15)",
            borderColor: "oklch(0.66 0.10 72 / .35)",
            color: "var(--gold-deep)",
          }}
        >
          Esta e sua primeira entrada. Recomendamos trocar a senha agora.
        </div>
      )}

      <div className="adm-panel" style={{ maxWidth: 520 }}>
        <h2 className="adm-panel-title" style={{ marginBottom: 14 }}>Trocar senha</h2>
        {admin && (
          <p className="adm-sub" style={{ marginBottom: 22 }}>
            Conta: <strong>{admin.email}</strong>
          </p>
        )}
        <form onSubmit={submit} noValidate className="fx-form" style={{ margin: 0, maxWidth: 420 }}>
          <Field label="Senha atual" type="password" value={current} onChange={setCurrent} autoComplete="current-password" />
          <Field label="Nova senha (min. 8 caracteres)" type="password" value={next} onChange={setNext} autoComplete="new-password" />
          <Field label="Confirme a nova senha" type="password" value={confirm} onChange={setConfirm} autoComplete="new-password" />
          {msg && (
            <div className="adm-login-error" style={msg.kind === "ok" ? {
              background: "oklch(0.56 0.115 158 / .12)",
              borderColor: "oklch(0.56 0.115 158 / .35)",
              color: "var(--green)",
            } : undefined}>
              {msg.text}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            className={`btn btn-primary ${submitting ? "is-wait" : ""}`}
            style={{ padding: "14px 24px", fontSize: 15 }}
          >
            {submitting ? "Trocando..." : "Trocar senha"}
          </button>
        </form>
      </div>
    </>
  );
}
